export default "__VITE_ASSET__CFI33MqB__"